export function getBalanceColor(balance: number) {
    if (balance > 0) {
        return 'var(--ant-color-success-text)';
    } else if (balance < 0) {
        return 'var(--ant-color-error-text)';
    } else {
        return 'var(--ant-color-warning-text)';
    }
}
